export type LineDiscountType = "percent" | "amount";

function roundMoney(value: number): number {
  return Math.round((Number(value) || 0) * 100) / 100;
}

export const INVOICE_PAYMENT_TERMS = [
  { value: "due_on_receipt", label: "Due on Receipt", days: 0 },
  { value: "net_5", label: "Net 5", days: 5 },
  { value: "net_7", label: "Net 7", days: 7 },
  { value: "net_10", label: "Net 10", days: 10 },
  { value: "net_15", label: "Net 15", days: 15 },
  { value: "net_30", label: "Net 30", days: 30 },
  { value: "net_45", label: "Net 45", days: 45 },
  { value: "net_60", label: "Net 60", days: 60 },
  { value: "net_90", label: "Net 90", days: 90 },
  { value: "custom", label: "Custom", days: null },
] as const;

export function paymentTermsLabel(value: string | null | undefined): string {
  const match = INVOICE_PAYMENT_TERMS.find((t) => t.value === value);
  return match?.label || (value || "").trim() || "—";
}

export function dueDateFromTerms(issueDate: string, terms: string): string {
  const days = INVOICE_PAYMENT_TERMS.find((t) => t.value === terms)?.days;
  if (days == null) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec((issueDate || "").trim());
  if (!match) return "";
  const d = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function computeLineAmounts(line: {
  quantity?: number | null;
  unitPrice?: number | null;
  discountValue?: number | null;
  discountType?: LineDiscountType | string | null;
  taxRate?: number | null;
}): { base: number; discount: number; amount: number; taxAmount: number } {
  const quantity = Number(line.quantity) || 0;
  const unitPrice = Number(line.unitPrice) || 0;
  const base = roundMoney(quantity * unitPrice);
  const discountValue = Math.max(0, Number(line.discountValue) || 0);
  const discountType = line.discountType === "amount" ? "amount" : "percent";
  let discount =
    discountType === "amount" ? roundMoney(discountValue) : roundMoney(base * (discountValue / 100));
  if (discount > base) discount = base;
  const amount = roundMoney(Math.max(0, base - discount));
  const taxRate = Math.max(0, Number(line.taxRate) || 0);
  const taxAmount = roundMoney(amount * (taxRate / 100));
  return { base, discount, amount, taxAmount };
}
